<template>
  <div class="dimed">
    <div class="layer layer--sm">
      <div class="layer__body">
        <div class="alt-tit">{{title}}</div>
        <div class="ft--xlg ft--bold">
          {{content}}
        </div>
      </div>
    </div>
  </div>
  <PosTransaction v-if="posTransactionYn" :text="text" :url="tranUrl" :param="param" @posTransactionNextStep="posTransactionNextStep" />
</template>
<script>
import axios from 'axios';
import posTransaction from '@/components/modal/payment/PosTransaction.vue';

export default {
  name: 'registrationIng',
  data() {
    return {
      baskets: this.$store.getters.getBaskets,
      title : '',
      content : '',
      posTransactionYn : false,
      tranUrl: '',
      text: '',
      param : {},
      oneCallYn: false,
    };
  },
  mounted() {
    if(this.settleType === 'USED_SALE'){
      this.title    = this.$t('User.Order.msg28');
      this.content  = this.$t('User.Order.msg30');
      this.arbitrarysalesRegist();
    }else{
      this.title    = this.$t('User.Order.msg29');
      this.content  = this.$t('User.Order.msg31');
      this.manualreturnStart();
    }
  },
  props: {
    settleType : String,
  },
  methods: {
    posTransactionNextStep() {
      this.posTransactionYn = false;
      if(this.settleType === 'USED_SALE'){
        if (this.tranUrl == '/api/admin/arbitrarysales/payment') {
          this.arbitrarysalesComplete();
        } else {
          setTimeout(() => {
            this.$emit('regisIngClose');
          }, 2000);
        }
      }else{
        if (this.tranUrl == '/api/admin/manualreturn/payment') {
          this.manualreturnComplete();
        } else {
          setTimeout(() => {
            this.$emit('regisIngClose');
          }, 2000);
        }
      }
    },
    arbitrarysalesRegist(){
      // 임의 매출
      // 1. 상품등록
      if (this.oneCallYn) return;
      this.oneCallYn = true;
      let url = '/api/admin/arbitrarysales/regist';
      let tran = _.cloneDeep(this.baskets);
      tran.ITEMLIST.forEach((item) => {
        item.ITEM_NM = item.ORG_ITEM_NM;
      });

      tran.PAYMENTLIST = [
        {
          SETTLE_TYPE: this.settleType,
          PAYMENT_AMT: tran.HEADER.SALES_AMT,
        },
      ];
      axios.post(url, tran).then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Arbitrarysales Regist Success`);
            this.arbitrarysalesPayment();
          } else {
            this.$logInfo(`Arbitrarysales Regist Fail status : ${response.data.status} message : ${response.data.message}`);
            this.$emit('paymentError');
            this.oneCallYn = false;
          }
      }).catch((error) => {
          this.$logInfo(`Arbitrarysales Regist axios Error : ${error}`);
          this.$emit('paymentError');
          this.oneCallYn = false;
      })
    },
    arbitrarysalesPayment(){
      // 임의 매출
      // 2. 결제 정보 전송S
      let url = '/api/admin/arbitrarysales/payment';

      axios.post(url).then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Arbitrarysales Payment Success`);
            this.arbitrarysalesComplete();
          } else {
            this.posTransactionYn = true;
            this.text = this.$t('Modal.Payment.msg6');
            this.tranUrl = '/api/admin/arbitrarysales/payment';
            this.param = {}
            this.$logInfo(`Arbitrarysales Payment Fail status : ${response.data.status} message : ${response.data.message}`);
          }
      }).catch((error) => {
          this.posTransactionYn = true;
          this.text = this.$t('Modal.Payment.msg6');
          this.tranUrl = '/api/admin/arbitrarysales/payment';
          this.param = {}
          this.$logInfo(`Arbitrarysales Payment axios Error : ${error}`);
      })
    },
    arbitrarysalesComplete(){
      // 임의 매출
      // 3. 거래 완료
      let url = '/api/admin/arbitrarysales/complete';
      
      axios.post(url).then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Arbitrarysales Complete Success`);
            setTimeout(() => {
              this.$emit('regisIngClose');
            }, 2000);
          } else {
            this.posTransactionYn = true;
            this.text = this.$t('Modal.Payment.msg7');
            this.tranUrl = '/api/admin/arbitrarysales/complete';
            this.param = {}
            this.$logInfo(`Arbitrarysales Complete Fail status : ${response.data.status} message : ${response.data.message}`);
          }
      }).catch((error) => {
          this.posTransactionYn = true;
          this.text = this.$t('Modal.Payment.msg7');
          this.tranUrl = '/api/admin/arbitrarysales/complete';
          this.param = {}
          this.$logInfo(`Arbitrarysales Complete axios Error : ${error}`);
      }).finally(() => {
          this.oneCallYn = false;
      });
    },
    manualreturnStart(){
      // 수기반품
      // 1. 선언
      if (this.oneCallYn) return;
      this.oneCallYn = true;
      let url = '/api/admin/manualreturn/start';
      axios.post(url).then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Manualreturn Start Success`);
            this.manualreturnRegist();
          } else {
            this.$logInfo(`Manualreturn Start Fail status : ${response.data.status} message : ${response.data.message}`);
            this.$emit('paymentError');
            this.oneCallYn = false;
          }
      }).catch((error) => {
          this.$logInfo(`Manualreturn Start axios Error : ${error}`);
          this.$emit('paymentError');
          this.oneCallYn = false;
      })
    },
    manualreturnRegist(){
      // 수기반품
      // 2. 상품등록
      let url = '/api/admin/manualreturn/regist';
      let tran = _.cloneDeep(this.baskets);
      tran.ITEMLIST.forEach((item) => {
        item.ITEM_NM = item.ORG_ITEM_NM;
      });

      tran.PAYMENTLIST = [
        {
          SETTLE_TYPE: this.settleType,
          PAYMENT_AMT: tran.HEADER.SALES_AMT,
        },
      ];

      axios.post(url,tran).then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Manualreturn Regist Success`);
            this.manualreturnPayment();
          } else {
            this.$logInfo(`Manualreturn Regist Fail status : ${response.data.status} message : ${response.data.message}`);
            this.$emit('paymentError');
            this.oneCallYn = false;
          }
      }).catch((error) => {
          this.$logInfo(`Manualreturn Regist axios Error : ${error}`);
          this.$emit('paymentError');
          this.oneCallYn = false;
      })
    },
    manualreturnPayment(){
      // 수기반품
      // 3. 결제등록
      let url = '/api/admin/manualreturn/payment';

      axios.post(url).then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Manualreturn Payment Success`);
            this.manualreturnComplete();
          } else {
            this.posTransactionYn = true;
            this.text = this.$t('Modal.Payment.msg6');
            this.tranUrl = '/api/admin/manualreturn/payment';
            this.param = {}
            this.$logInfo(`Manualreturn Payment Fail status : ${response.data.status} message : ${response.data.message}`);
          }
      }).catch((error) => {
          this.posTransactionYn = true;
          this.text = this.$t('Modal.Payment.msg6');
          this.tranUrl = '/api/admin/manualreturn/payment';
          this.param = {}
          this.$logInfo(`Manualreturn Payment axios Error : ${error}`);
      })
    },
    manualreturnComplete(){
      // 수기반품
      // 4. 완료
      let url = '/api/admin/manualreturn/complete';

      axios.post(url).then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Manualreturn Complete Success`);
            setTimeout(() => {
              this.$emit('regisIngClose');
            }, 2000);
          } else {
            this.posTransactionYn = true;
            this.text = this.$t('Modal.Payment.msg7');
            this.tranUrl = '/api/admin/manualreturn/complete';
            this.param = {}
            this.$logInfo(`Manualreturn Complete Fail status : ${response.data.status} message : ${response.data.message}`);
          }
      }).catch((error) => {
          this.posTransactionYn = true;
          this.text = this.$t('Modal.Payment.msg7');
          this.tranUrl = '/api/admin/manualreturn/complete';
          this.param = {}
          this.$logInfo(`Manualreturn Complete axios Error : ${error}`);
      }).finally(() => {
          this.oneCallYn = false;
      });
    },
  },
  watch: {},
  components: {
    PosTransaction: posTransaction,
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src='@/assets/css/user/pages/admin.css' scoped></style>
<style scoped></style>
